import React, { useEffect, useState, useRef } from 'react';
import { motion, easeInOut, easeIn, easeOut } from "framer-motion"
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
// import { Button } from "./ui/button"
// import { Card, CardContent, CardHeader } from "./ui/card"
import { Badge } from "./ui/badge"
import {
  MapPin, Phone, Mail,
  // CreditCard, Calendar, Clock,
  Crown,
  Calendar, Search, Loader2,
  ReceiptText
} from 'lucide-react';
import { thp_inviteImg } from './lib/thpImg';
import { thp_inviteImg_2026 } from './lib/thpImg_2026';
// import {
//     Shield, Lock, Star, AlertTriangle, User, Eye,
//     XCircle, AlertCircle
// } from "lucide-react"

interface ReceiptItem {
  id: string;
  name: string;
  description?: string;
  quantity: number;
  price: number;
}

interface ReceiptProps {
  formData?: any,
  downloadReceipt?: boolean,
  set_downloadReceipt?: any,
  storeName?: string;
  storeAddress?: string;
  storePhone?: string;
  storeEmail?: string;
  receiptNumber?: string;
  date?: string;
  time?: string;
  cashierName?: string;
  customerName?: string;
  items?: ReceiptItem[];
  subtotal?: number;
  tax?: number;
  total?: number;
  paymentMethod?: string;
  cardLast4?: string;
}

const Receipt: React.FC<ReceiptProps> = ({ formData, downloadReceipt, set_downloadReceipt }) => {
  const [user, setUser] = useState<any>(null);
  const ref = useRef<HTMLDivElement>(null)

  const handleDownload = async () => {
    if (!ref.current) return;
    const canvas = await html2canvas(ref.current);
    const image = canvas.toDataURL('image/png');

    const link = document.createElement('a');
    link.href = image;
    link.download = 'thp-vip.png';
    link.click();
  };

  useEffect(() => {
    if (user && downloadReceipt === true) {
      handleDownload();
      setTimeout(() => {
        set_downloadReceipt(false)
      }, 200);
    }
  }, [downloadReceipt])

  useEffect(() => {
    const fetchUser = async () => {
      const response = await getUserData(formData.email_address);
      setTimeout(() => {
        setUser(response);
      }, 2000);
    };

    fetchUser();
  }, []);



  const ReturnReceipt = () => {
    return (
      <div ref={ref} className="min-h-screen shadow-2xl rounded-2xl mb-3 bg-gradient-to-br from-slate-500 to-slate-500 p-4 flex items-center justify-center">
        <div className="bg-gradient-to-r from-slate-800 to-slate-700 shadow-2xl rounded-2xl overflow-hidden w-full">
          {/* Header */}
          <div className="bg-gradient-to-r from-slate-800 to-slate-700 text-white p-4 text-center">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="flex items-center justify-center gap-3 mb-4"
            >
              <div className="relative flex items-center justify-center">
                <div className="absolute -top-1 w-3 h-3 bg-fuchsia-400 rounded-full animate-pulse"></div>
              </div>
              <div className="bg-gradient-to-r from-fuchsia-500 to-rose-500 text-white px-4 text-sm font-semibold rounded-2xl h-3 flex justify-center items-center">
                <p>
                  VIP INVITE
                </p>
              </div>
              <div className="relative flex items-center justify-center">
                <div className="absolute -top-1 w-3 h-3 bg-fuchsia-400 rounded-full animate-pulse"></div>
              </div>
            </motion.div>
            <div className="space-y-1 text-slate-200 text-sm">
              <h1 className='text-white text-3xl font-bold'>{`TSO/${user?._data?.id}/THP-VIP`}</h1>
              <div className="flex items-center justify-center space-x-4">
                <p>the above is your vip code:</p>
              </div>
            </div>
          </div>

          {/* <h1>User: {JSON.stringify(formData.email_address)}</h1> */}
          {/* Receipt Details */}
          <div className="p-2">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
              className="relative aspect-[4/5] md:aspect-[4/5] md:block flex justify-center items-center bg-black overflow-hidden rounded-3xl mb-8 md:mb-0"
            >
              {/* Image as background */}
              <img
                // src="https://tsoministries.com/wp-content/uploads/2025/07/thp_new.jpeg"
                src={thp_inviteImg_2026}
                alt="Healing Party"
                className="absolute top-0 left-0 w-full h-full object-cover z-0"
              />

              {/* QR Code */}
              <div className="absolute z-10 w-[220px] h-[220px] rounded-3xl flex justify-center items-center bg-[#f0f0f0] bottom-2 right-2">
                <QRCodeSVG
                  value={`https://tsoministries.com/unveil?code=thp:TSO/${user?._data?.id}/THP-VIP`}
                  size={190}
                  bgColor="#f0f0f0"
                  fgColor="#2D3748"
                  level="H"
                />
              </div>
            </motion.div>
          </div>

          {/* Footer */}
          <div className="p-6 bg-slate-50 text-center rounded-2xl">
            <div className="space-y-3 text-sm text-slate-600">
              <p className="font-semibold">Thank you accepting this invite!</p>
              <p>For more informations, visit our website or chat us an email: admin@tsoministries.com</p>
              <div className="pt-3 border-t border-slate-200">
                <p className="text-xs text-slate-500">
                  This receipt was generated electronically
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  };

  const ReturnLoading = () => {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md mx-auto mb-8"
      >
        <motion.div
          variants={pulseVariants}
          animate="pulse"
          className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-8 shadow-2xl text-center"
        >
          <div className="flex items-center justify-center mb-6">
            <div className="relative">
              <div className="w-20 h-20 bg-gradient-to-br from-gray-400 to-gray-400 rounded-full flex items-center justify-center">
                <ReceiptText className="w-10 h-10 text-white" />
              </div>
              <motion.div
                variants={spinVariants}
                animate="spin"
                className="absolute -top-2 -right-2 w-8 h-8 bg-fuchsia-500 rounded-full flex items-center justify-center"
              >
                <Loader2 className="w-5 h-5 text-white" />
              </motion.div>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Fetching Receipt
          </h2>

          <p className="text-gray-600 mb-6">
            Please wait while we Fetch your Receipt...
          </p>

          <div className="flex items-center justify-center space-x-2">
            <motion.div
              variants={dotVariants}
              animate="animate"
              className="w-3 h-3 bg-fuchsia-500 rounded-full"
            />
            <motion.div
              variants={dotVariants}
              animate="animate"
              transition={{ delay: 0.2 }}
              className="w-3 h-3 bg-fuchsia-500 rounded-full"
            />
            <motion.div
              variants={dotVariants}
              animate="animate"
              transition={{ delay: 0.4 }}
              className="w-3 h-3 bg-fuchsia-500 rounded-full"
            />
          </div>

          <div className="mt-6 text-sm text-gray-500">
            This may take a few moments
          </div>
        </motion.div>
      </motion.div>
    );
  }

  return (
    user ? ReturnReceipt() : ReturnLoading()
  )
};

export default Receipt;












async function getUserData(email: any) {
  const endpoint = 'https://tsoministries.com/wp-json/wp/v2/thp';
  let page = 1;
  let emailExists = false;
  let _data = [];

  try {
    while (true) {
      const response = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=id,email_address,vip`);

      if (!response.ok) {
        // If 400 and page > 1, assume we've reached the end
        if (response.status === 400 && page > 1) {
          break;
        }
        throw new Error(`Error fetching page ${page}`);
      }

      const data = await response.json();

      if (!Array.isArray(data) || data.length === 0) {
        break;
      }

      for (const item of data) {
        if (item.email_address && item.email_address.toLowerCase() === email.toLowerCase()) {
          emailExists = true;
          _data = item;
          break;
        }
      }

      if (emailExists || data.length < 100) {
        break;
      }

      page++;
    }

    return { emailExists, _data } // true = available
  } catch (error) {
    console.error('Failed to check email v2:', error);
    return { emailExists, _data: null };
  }
}

const spinVariants = {
  spin: {
    rotate: 360,
    transition: {
      duration: 1,
      repeat: Infinity,
      ease: easeInOut
    }
  }
};

const pulseVariants = {
  pulse: {
    scale: [1, 1.05, 1],
    transition: {
      duration: 1.5,
      repeat: Infinity,
      ease: easeInOut
    }
  }
};

const dotVariants = {
  animate: {
    scale: [1, 1.2, 1],
    transition: {
      duration: 0.6,
      repeat: Infinity,
      ease: easeInOut
    }
  }
};









//   storeName = "Premium Store",
//   storeAddress = "123 Main Street, Downtown, NY 10001",
//   storePhone = "(555) 123-4567",
//   storeEmail = "contact@premiumstore.com",
//   receiptNumber = "RCP-2024-001234",
//   date = "January 15, 2024",
//   time = "2:45 PM",
//   cashierName = "Sarah Johnson",
//   customerName = "John Smith",
//   items = [
//     {
//       id: "1",
//       name: "Premium Wireless Headphones",
//       description: "Noise-canceling, Bluetooth 5.0",
//       quantity: 1,
//       price: 299.99
//     },
//     {
//       id: "2",
//       name: "USB-C Cable",
//       description: "3ft braided cable",
//       quantity: 2,
//       price: 24.99
//     },
//     {
//       id: "3",
//       name: "Phone Case",
//       description: "Clear protective case",
//       quantity: 1,
//       price: 39.99
//     }
//   ],
//   subtotal = 389.97,
//   tax = 31.20,
//   total = 421.17,
//   paymentMethod = "Credit Card",
//   cardLast4 = "4532"
// 